import React, {useEffect} from 'react';
import './Banner.css';

// const BannerContent = () => {


//     return (

//     )
// }

const Banner = () => {

    useEffect(() => {
        console.log('Banner mounted');
    }, []);
    

    const bannerStyle = {
        padding: '0 7%',
        minHeight: '50rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: `linear-gradient(rgba(75, 83, 186, 0.3), rgba(255, 255, 255, 0.0)), url(${process.env.PUBLIC_URL}/assets/img/banner.jpg)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
    };

    return (
        <div style={bannerStyle}>
            <div id="banner_text_div">
            <h1>Développeur d’applications mobiles & web</h1>
            <h2>Conception • Développement • Gestion de projet</h2>
            </div>
        </div>
    );
}

export default Banner;